import { render, staticRenderFns } from "./ServiceProviderBrandIcon.vue?vue&type=template&id=12138ce5&"
import script from "./ServiceProviderBrandIcon.vue?vue&type=script&lang=ts&"
export * from "./ServiceProviderBrandIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports